import {Fragment} from "react";
import {HeaderMall9} from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import FooterMall9 from "../../../../publicComponent/Footer/FooterMall9";
import NewsContext, {NewsController, useNewsContext} from "../../../../reducer/moduleReducer/news";
import {useEffect} from "react";
import { getI18n } from "react-i18next";

function NewsWrap() {
  const { getNewsList, selectNews } = NewsController();
  const { state } = useNewsContext();
  const lang = getI18n().language;
  
  useEffect(() => {
    getNewsList();
  }, []);
  
  return (
    <Navigator.container className="min-h-[40vh]">
      {
        state.newsList.records &&
        <div className="md:py-[24px] divide-y">
          {
            state.newsList.records.map((item, i) => (
              <Fragment key={i}>
                <div onClick={() => selectNews(i)}
                     className="md:py-[24px] cursor-pointer flex md:pr-[20px]
                      mdmax:px-[20px] mdmax:py-[12px]">
                  <p className="flex-1 text-[17px]">{lang === 'en'?item.titleEn:item.title}</p>
                  <i className="iconfont icon-right"
                     style={{ transform: `rotate(${!item.active ? 0 : 90}deg)` }}/>
                </div>
                {
                  item.active &&
                  <div className="pt-[12px] pb-[20px] mdmax:px-[15px]">
                    <div className="text-center">
                      <img src={item.picUrlView} className="inline-block"/>
                    </div>
                    <p className="text-[#999] py-[15px]">{item.createTime}</p>
                    <div dangerouslySetInnerHTML={{ __html: lang === 'en'?item.contentEn:item.content }}/>
                  </div>
                }
              </Fragment>
            ))
          }
        </div>
      }
    </Navigator.container>
  );
}

export default function News() {
  return (
    <>
      <HeaderMall9/>
      <Navigator title="资讯分享" goback/>
      <NewsContext>
        <NewsWrap/>
      </NewsContext>
      <FooterMall9 noTabs/>
    </>
  );
}
